__turbopack_context__.v({
  "cardIconStat": "CardIconStat-module-scss-module__5VjQaq__cardIconStat",
  "cardLinkWrap": "CardIconStat-module-scss-module__5VjQaq__cardLinkWrap",
  "copy": "CardIconStat-module-scss-module__5VjQaq__copy",
  "icon": "CardIconStat-module-scss-module__5VjQaq__icon",
  "inner": "CardIconStat-module-scss-module__5VjQaq__inner",
  "stat": "CardIconStat-module-scss-module__5VjQaq__stat",
});
